"use client";

import { useEffect } from "react";
import { SVGInjector } from "@tanem/svg-injector";
import type { TTextColors } from "@hsr/types";

export const useSvgInjector = (
  icon: string | undefined,
  id: string | undefined,
  color: TTextColors
) => {
  useEffect(() => {
    if (!icon || icon.length === 0) return;
    if (!id || id.length === 0) return;

    SVGInjector(document.getElementById(id), {
      beforeEach(svg) {
        svg.setAttribute("class", `text-${color}`);
        svg.setAttribute("color", `currentColor`);
        // svg.setAttribute("width", `24px`);
        // svg.setAttribute("height", `24px`);
      },
      afterEach(err) {
        if (err) return;

        const el = document.getElementById(id);
        if (!el) return;

        const elPaths = el.querySelectorAll("path");
        if (!elPaths || elPaths.length === 0) return;

        elPaths.forEach((p) => {
          p.removeAttribute("stroke");
          p.setAttribute("stroke", "currentColor");
        });
      }
    });
  }, [color, icon, id]);
};
